import { createAlchemyWeb3 } from "@alch/alchemy-web3";
export const alchemyWeb3 = createAlchemyWeb3(
  "https://eth-mainnet.g.alchemy.com/v2/FeBF4O8PdhwNkQFNYAnjpWkjBuq74TMQ"
);
